import authgear from "@authgear/web";

// `npm start` sets this flag only for the local development server. Production
// builds import the real SDK and cannot issue this token.
const LOCAL_BYPASS_TOKEN = "local-auth-bypass";
const useLocalAuthBypass = process.env.NODE_ENV === "development"
    && process.env.REACT_APP_LOCAL_AUTH_BYPASS === "true";

const localAuthgear = {
    sessionState: "AUTHENTICATED",
    accessToken: LOCAL_BYPASS_TOKEN,
    configure: async () => {},
    finishAuthentication: async () => {},
    refreshAccessTokenIfNeeded: async () => {},
    startAuthentication: async () => {},
    logout: async () => {},
};

export default useLocalAuthBypass ? localAuthgear : authgear;
